let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hWZz2")).then(() => parcelRequire('33kXB'));